import get from 'lodash/get'
import set from 'lodash/set'
import { identify, track } from './tracking'
import { blacklistWebhooks, whitelistWebhooks } from './integrations'
import {
  answerEvent,
  formEvent,
  interactionFormEvent,
  interactionQuestionEvent,
} from './events'

export function trackFormSubmit({ formId, formValues, fields, inputMap }) {
  const formField = fields
    .find(({ additional }) => {
      return get(additional, 'form.componentId') === formId
    })

  if (!formField) {
    return
  }

  const inputFieldList = get(formField, 'additional.form.inputs')

  const mappedFormValues = Object.keys(formValues)
    .map((fieldName) => {
      const inputId = inputMap.byName[formId][fieldName]
      const inputField = inputFieldList.find(({ componentId }) => {
        return componentId === inputId
      })

      if (inputField) {
        return {
          inputField: inputField,
          value: formValues[fieldName],
        }
      }
    })
    .filter(Boolean)

  updateUser(mappedFormValues)
  trackInteractionFormEvent(formField, mappedFormValues)
  // trackFormEvent(mappedFormValues)
}

export function updateUser(mappedFormValues) {
  const identifyTraits = {}

  mappedFormValues.forEach(({ inputField, value }) => {
    set(identifyTraits, inputField.fieldName, value)
  })

  identify(identifyTraits)
}

export function trackFormEvent(mappedFormValues) {
  const trackingObj = {}

  mappedFormValues.forEach(({ inputField, value }) => {
    trackingObj[inputField.fieldName] = value
  })

  track(formEvent, trackingObj, blacklistWebhooks)
}

export function trackInteractionFormEvent(formField, mappedFormValues) {
  const trackingObj = {
    componentId: formField.componentId, // question form
    fieldId: formField._id,
    optIns: mappedFormValues
      .map(({ value, inputField }) => {
        return {
          componentId: inputField.componentId, // input
          value: value,
        }
      }),
  }

  track(interactionFormEvent, trackingObj, whitelistWebhooks)
}

export function trackAnswerClick({ answer, fields }) {
  const questionField = fields
    .find(({ componentId }) => {
      return answer.parentId === componentId
    })

  if (!questionField) {
    return
  }

  const answerField = questionField.additional.answers
    .find(({ componentId }) => {
      return answer._id === componentId
    })

  if (!answerField) {
    return
  }

  trackInteractionQuestionEvent(questionField, answerField)
  trackAnswerEvent(questionField, answerField)
  identify({
    [questionField.title]: answerField.value,
  })
}

export function trackInteractionQuestionEvent(field, answerField) {
  const trackingObj = {
    componentId: field.componentId, // question text / question media
    fieldId: field._id,
    answerId: answerField.componentId,
  }

  track(interactionQuestionEvent, trackingObj, whitelistWebhooks)
}

export function trackAnswerEvent(field, answerField) {
  const trackingObj = {
    [field.title]: answerField.value,
    question: field.title,
    answer: answerField.value,
  }

  track(answerEvent, trackingObj, blacklistWebhooks)
}

export function trackButtonClick(id) {
  const name = id || 'button_click'
  const trackingObj = {}

  track(name, trackingObj, blacklistWebhooks)
}

export function trackVisit() {
  const name = 'visit'
  const trackingObj = {}

  track(name, trackingObj)
}
